import { useQuery } from "@apollo/client";
import { GET_STATS } from "@store/operations/analyticsOperations";

export const useGetStats = () => useQuery(GET_STATS);